'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
type RampWrapperProps = {
  pubId?: string;
  websiteId?: string;
  isEnabled?: boolean;
};
const scriptId = 'ramp-config-script';

/**
 * Playwire's ramp script loader component
 * ref: https://support.playwire.com/implement-the-next.js-component-simple-implementation
 */
export default function RampWrapper({
  pubId,
  websiteId,
  isEnabled
}: RampWrapperProps) {
  const pathname = usePathname() ?? '/';
  const [rampComponentLoaded, setRampComponentLoaded] = useState(false);
  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    if (!pubId || !websiteId) {
      console.warn('[RAMP] Missing Publisher Id or Website Id');
      return;
    }
    if (!rampComponentLoaded) {
      // Ensure ramp object exists
      window.ramp = window.ramp || {
        que: []
      };
      window.ramp.que = window.ramp.que || [];
      window.ramp.passiveMode = true;

      // Load the Ramp configuration script
      const configScript = document.createElement('script');
      configScript.id = scriptId;
      configScript.src = `https://cdn.intergient.com/${pubId}/${websiteId}/ramp.js`;
      configScript.dataset['cfasync'] = 'false';
      configScript.async = true;
      configScript.defer = true;
      document.body.appendChild(configScript);
      configScript.onload = () => {
        setRampComponentLoaded(true);
      };
    }
    return () => {};
  }, [isEnabled, pubId, rampComponentLoaded, websiteId]);
  useEffect(() => {
    if (!rampComponentLoaded || !isEnabled) return;
    let attempts = 0;
    const maxAttempts = 20; // ~10s if interval=500ms
    const interval = 500;
    const timer = setInterval(() => {
      attempts++;
      const hasRampEl = document.querySelector('[data-holder="pwramp"]');
      if (hasRampEl) {
        window.ramp?.que.push(() => {
          window.ramp?.spaNewPage?.(pathname);
        });
        clearInterval(timer);
      } else if (attempts >= maxAttempts) {
        console.warn('[RAMP] Element not found within max attempts on', pathname);
        clearInterval(timer);
      }
    }, interval);
    return () => clearInterval(timer);
  }, [isEnabled, pathname, rampComponentLoaded]);
  return null;
}